import {Route,Switch,BrowserRouter } from "react-router-dom";

import AvailabilitySlotsTable from "components/Doobi/AvailabilitySlots";
import DoobiHeader from "components/Headers/DoobiHeader";
import SlotsUtilizationTable from "components/Doobi/SlotsUtilization";
import SchedulingTable from "components/Doobi/Scheduling";

const AvailabilitySlotsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Slots" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/schedule`} component={SchedulingTable}/>
      <Route path={`${match.path}/utilization`} component={SlotsUtilizationTable}/>
      <Route path={`${match.path}/`} component={AvailabilitySlotsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default AvailabilitySlotsRoute;
